// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Footer Styles */
.footer {
  background-color: #1a2b3c;
  color: #ecf0f1;
  padding: 50px 0 20px;
  width: 100%;
  position: relative;
  z-index: 2;
  font-family: 'Arial', sans-serif;
  flex-shrink: 0;
  margin-top: auto;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
}

.footer-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 2;
}

.footer-section {
  flex: 1 1;
  min-width: 250px;
  margin-bottom: 20px;
  padding: 0 15px;
}

.footer-section h3 {
  color: #fff;
  margin-bottom: 20px;
  font-size: 1.3rem;
  position: relative;
  padding-bottom: 10px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.footer-section h3::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 40px;
  height: 3px;
  background-color: #4a90e2;
  border-radius: 2px;
}

.footer-section ul {
  list-style: none;
  padding: 0;
}

.footer-section ul li {
  margin-bottom: 10px;
}

.footer-section a {
  color: #bdc3c7;
  text-decoration: none;
  transition: all 0.3s ease;
  font-size: 0.95rem;
}

.footer-section a:hover {
  color: #4a90e2;
  text-decoration: none;
  padding-left: 5px;
}

.footer-section p {
  margin: 12px 0;
  line-height: 1.7;
  color: #bdc3c7;
  font-size: 0.95rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    align-items: flex-start;
    padding: 0 30px;
  }
  
  .footer-section {
    width: 100%;
    margin-bottom: 30px;
  }
  
  .footer {
    padding: 40px 0 20px;
  }
}

.social-links {
  display: flex;
  gap: 12px;
  margin-top: 20px;
}

.social-links a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.08);
  border-radius: 50%;
  transition: all 0.3s ease;
  color: #ecf0f1;
  font-size: 18px;
}

.social-links a:hover {
  background-color: #4a90e2;
  transform: translateY(-3px);
  color: white;
}

.social-icon {
  font-size: 1.2rem;
}

.footer-bottom {
  text-align: center;
  padding-top: 25px;
  margin-top: 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  font-size: 0.9rem;
  color: #8a9aaf;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .footer {
    padding: 45px 0 20px;
  }

  .footer-content {
    padding: 0 25px;
  }

  .footer-section {
    min-width: 220px;
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 40px 0 20px;
  }

  .footer-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 0 30px;
  }
  
  .footer-section {
    margin-bottom: 30px;
    width: 100%;
    min-width: auto;
  }
  
  .footer-section h3 {
    font-size: 1.2rem;
  }

  .footer-section h3::after {
    left: 50%;
    transform: translateX(-50%);
  }
  
  .social-links {
    justify-content: center;
  }

  .footer-bottom {
    font-size: 0.875rem;
  }
}

@media (max-width: 480px) {
  .footer {
    padding: 35px 0 15px;
  }

  .footer-content {
    padding: 0 20px;
  }

  .footer-section {
    padding: 0 10px;
    margin-bottom: 25px;
  }

  .footer-section h3 {
    font-size: 1.1rem;
    margin-bottom: 16px;
    padding-bottom: 8px;
  }

  .footer-section h3::after {
    width: 35px;
    height: 2.5px;
  }

  .footer-section a,
  .footer-section p {
    font-size: 0.875rem;
  }

  .footer-section ul li {
    margin-bottom: 8px;
  }

  .social-links {
    gap: 10px;
    margin-top: 16px;
  }

  .social-links a {
    width: 36px;
    height: 36px;
    font-size: 16px;
  }

  .footer-bottom {
    font-size: 0.8125rem;
    padding-top: 20px;
    margin-top: 25px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,gCAAgC;EAChC,cAAc;EACd,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,+CAA+C;EAC/C,iBAAiB;EACjB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;EAClB;AACF","sourcesContent":["/* Footer Styles */\n.footer {\n  background-color: #1a2b3c;\n  color: #ecf0f1;\n  padding: 50px 0 20px;\n  width: 100%;\n  position: relative;\n  z-index: 2;\n  font-family: 'Arial', sans-serif;\n  flex-shrink: 0;\n  margin-top: auto;\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.footer-content {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n  position: relative;\n  z-index: 2;\n}\n\n.footer-section {\n  flex: 1;\n  min-width: 250px;\n  margin-bottom: 20px;\n  padding: 0 15px;\n}\n\n.footer-section h3 {\n  color: #fff;\n  margin-bottom: 20px;\n  font-size: 1.3rem;\n  position: relative;\n  padding-bottom: 10px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.footer-section h3::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 40px;\n  height: 3px;\n  background-color: #4a90e2;\n  border-radius: 2px;\n}\n\n.footer-section ul {\n  list-style: none;\n  padding: 0;\n}\n\n.footer-section ul li {\n  margin-bottom: 10px;\n}\n\n.footer-section a {\n  color: #bdc3c7;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  font-size: 0.95rem;\n}\n\n.footer-section a:hover {\n  color: #4a90e2;\n  text-decoration: none;\n  padding-left: 5px;\n}\n\n.footer-section p {\n  margin: 12px 0;\n  line-height: 1.7;\n  color: #bdc3c7;\n  font-size: 0.95rem;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .footer-content {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 0 30px;\n  }\n  \n  .footer-section {\n    width: 100%;\n    margin-bottom: 30px;\n  }\n  \n  .footer {\n    padding: 40px 0 20px;\n  }\n}\n\n.social-links {\n  display: flex;\n  gap: 12px;\n  margin-top: 20px;\n}\n\n.social-links a {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  background-color: rgba(255, 255, 255, 0.08);\n  border-radius: 50%;\n  transition: all 0.3s ease;\n  color: #ecf0f1;\n  font-size: 18px;\n}\n\n.social-links a:hover {\n  background-color: #4a90e2;\n  transform: translateY(-3px);\n  color: white;\n}\n\n.social-icon {\n  font-size: 1.2rem;\n}\n\n.footer-bottom {\n  text-align: center;\n  padding-top: 25px;\n  margin-top: 30px;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  font-size: 0.9rem;\n  color: #8a9aaf;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .footer {\n    padding: 45px 0 20px;\n  }\n\n  .footer-content {\n    padding: 0 25px;\n  }\n\n  .footer-section {\n    min-width: 220px;\n  }\n}\n\n@media (max-width: 768px) {\n  .footer {\n    padding: 40px 0 20px;\n  }\n\n  .footer-content {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    padding: 0 30px;\n  }\n  \n  .footer-section {\n    margin-bottom: 30px;\n    width: 100%;\n    min-width: auto;\n  }\n  \n  .footer-section h3 {\n    font-size: 1.2rem;\n  }\n\n  .footer-section h3::after {\n    left: 50%;\n    transform: translateX(-50%);\n  }\n  \n  .social-links {\n    justify-content: center;\n  }\n\n  .footer-bottom {\n    font-size: 0.875rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .footer {\n    padding: 35px 0 15px;\n  }\n\n  .footer-content {\n    padding: 0 20px;\n  }\n\n  .footer-section {\n    padding: 0 10px;\n    margin-bottom: 25px;\n  }\n\n  .footer-section h3 {\n    font-size: 1.1rem;\n    margin-bottom: 16px;\n    padding-bottom: 8px;\n  }\n\n  .footer-section h3::after {\n    width: 35px;\n    height: 2.5px;\n  }\n\n  .footer-section a,\n  .footer-section p {\n    font-size: 0.875rem;\n  }\n\n  .footer-section ul li {\n    margin-bottom: 8px;\n  }\n\n  .social-links {\n    gap: 10px;\n    margin-top: 16px;\n  }\n\n  .social-links a {\n    width: 36px;\n    height: 36px;\n    font-size: 16px;\n  }\n\n  .footer-bottom {\n    font-size: 0.8125rem;\n    padding-top: 20px;\n    margin-top: 25px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
